import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import exam from './modules/exam'
import index from './modules/index'
import course from './modules/course'
import pay from './modules/pay'
import {Message} from 'element-ui'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    current: Date.now(), // 当前时间
    intervalID: 0,
    message: undefined
  },
  mutations: {
    startComputeCurrent(state) {
      state.intervalID = setInterval(() => {
        state.current = Date.now()
      }, 1000)
    },
    stopComputeCurrent(state) {
      clearInterval(state.intervalID)
      state.intervalID = 0
    },
    showMessage(state, options) {
      if (state.message) {
        state.message.close()
      }
      if( options.message == 'timeout of 50000000ms exceeded' ){
        options.message = '连接超时，请检查网络';
        // return false;
      }
      if( options.message == 'Network Error' ){
        // options.message = '连接超时，请检查网络';
      }
	  

      state.message = Message({
        message: options.message,
        type: options.type || 'success',
        duration: options.duration || 2000,
        offset: 40
      })
    }
  },
  modules: {
    user,
    exam,
    index,
    course,
    pay,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js